import { pathOr } from 'ramda';
import { useEffect } from 'react';
import { ApplicationState } from 'src/store/ApplicationState.d';
import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { handleLogout } from 'src/store/authentication/authentication.requests';
import { AnyAction } from 'redux';
import { mkObject } from 'src/services/objects/build';
import { authenticatedUser } from 'src/utilities/storage';


type CombinedProps = DispatchProps & StateProps;

const Logout: React.FC<CombinedProps> = (props) => {
  const { dispatchLogout } = props;
  const payload = {
    id: authenticatedUser.accountId.get(),
    email: authenticatedUser.accountId.get(),
    object_meta: mkObject('account')
  }
  useEffect(() => {
    dispatchLogout(payload);
  }, [])

  return null;
}

interface StateProps {
  token: string;
}

const mapStateToProps: MapStateToProps<StateProps, {}, ApplicationState> = (
  state,
  ownProps
) => ({
  token: pathOr('', ['authentication', 'token'], state),
});

interface DispatchProps {
  dispatchLogout: (data: any) => void;
}

const mapDispatchToProps: MapDispatchToProps<DispatchProps, {}> = (
  dispatch: ThunkDispatch<ApplicationState, undefined, AnyAction>
) => {
  return {
    dispatchLogout: (data: any) =>
      dispatch(handleLogout(data)),
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps);

export default connected(Logout);
